export const isDev = () => {
  return (
    process.env.REACT_APP_NODE_ENV === "dev" ||
    process.env.REACT_APP_NODE_ENV === "development"
  );
};

export const isAndroidApp = () => {
  const userAgent = window.navigator.userAgent;
  return /mahi_app_android/.test(userAgent);
};

export const isIOSApp = () => {
  const userAgent = window.navigator.userAgent;
  return /mahi_app_ios/.test(userAgent);
};

export const isApp = () => {
  return isAndroidApp() || isIOSApp();
};

export const isWeb = () => {
  const userAgent = window.navigator.userAgent;
  return !!!/mahi_app/.test(userAgent);
};
export const getOS = () => {
  const userAgent = window.navigator.userAgent;

  let os = "web"; // 기본값: 웹

  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(userAgent)) {
    os = "Mac OS";
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    os = "iOS";
  } else if (/Windows/.test(userAgent)) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (/Linux/.test(userAgent)) {
    os = "Linux";
  }

  return os;
};

export function getCurrentAppVersion(): string | null {
  const userAgent = navigator.userAgent;
  const match = userAgent.match(/<(\d+\.\d+\.\d+)/);
  return match ? match[1] : null;
}
